<template>
  <div class="preview-container">
    <div class="preview-area" :class="[`size-${size}`]" ref="iframeParent">
      <!-- 插入iframe -->
    </div>
  </div>
</template>

<script>
import {
  onMounted, ref, inject, watch,
} from 'vue';

export default {
  name: 'print',
  props: {
    size: {
      type: String,
      default: 'A4',
    },
    data: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    template: [String],
  },
  setup(props) {
    const iframeParent = ref(null);

    const app = inject('app');
    let instance = null;
    onMounted(() => {
      instance = app.buildPrint({
        source: props.template,
        data: props.data,
      });
      instance.preview(iframeParent.value);
      watch(
        () => [props.data, props.template],
        () => {
          instance.rewrite({
            source: props.template,
            data: props.data,
          });
        },
        { deep: true },
      );
    });

    return {
      iframeParent,
      doPrint() {
        instance.print();
      },
      getHtml() {
        return instance.getHtml();
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.preview-container {
  .size-A4 {
    // 210mm * 297mm
    width: 840px;
    height: 1188px;
  }
}
</style>
